import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Colors, Title } from 'react-native-paper';

import { useSelector } from 'react-redux';
import { AppButton } from '../../../components/form';
import { Header } from '../../../components/common';
import styles from './styles';
import { API } from '../../../service/api';
import CardMonth from '../../../components/derivative/CardMonth';

const CompanyFinance = ({ navigation }) => {
  const { companyData } = useSelector((state) => state.company);
  const [dataFinances, setDataFinances] = useState([]);
  useEffect(() => {
    API.post('/search/financeiro', {
      where: `id_empresa = "${companyData.id_empresa}"`,
      orderby: 'data asc',
    }).then((response) => setDataFinances(response.data.data)).catch((err) => console.log(err));
  }, []);

  return (
    <>
      <Header navigation={navigation} profilePic={companyData.foto} userName={companyData.nome} />

      <View style={styles.viewBase}>
        <Title style={styles.title}>Financeiro</Title>
        {dataFinances.map((bill) => (
          <CardMonth
            key={bill.id_financeiro}
            paid={bill.cd_status === 'PAGO'}
            date={bill.data}
            value={bill.valor}
            boleto={bill.boleto}
            nf={bill.nota_fiscal}
          />
        ))}
        <AppButton
          size="bold"
          label="Voltar"
          rippleColor={Colors.white}
          style={styles.buttonBack}
          labelStyle={styles.textBack}
          onPress={() => navigation.goBack()}
        />
      </View>
    </>
  );
};

export default CompanyFinance;
